import React, { useState, useEffect } from "react";
import { createDfpAdComponent } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";
import { string, bool } from "prop-types";

const ViewPortSizeMapping920X90T1 = [
  {
    viewport: [1264, 0],
    sizes: [
      [970, 90],
      [728, 90],
    ],
  },
  {
    viewport: [876, 0],
    sizes: [
      [728, 90],
      [468, 60],
    ],
  },
  {
    viewport: [320, 0],
    sizes: [
      [320, 100],
      [320, 50],
    ],
  },
];

const ViewPortSizeMapping468x60B1 = [
  {
    viewport: [1264, 0],
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
    ],
  },
  {
    viewport: [876, 0],
    sizes: [
      [728, 90],
      [468, 60],
    ],
  },
  { viewport: [300, 0], sizes: [[300, 250]] },
];

const ViewPortSizeMappingFloating970x90 = [
  {
    viewport: [1264, 0],
    sizes: [
      [970, 90],
      [970, 66],
      [728, 90],
    ],
  },
  {
    viewport: [876, 0],
    sizes: [
      [728, 90],
      [468, 60],
    ],
  },
  {
    viewport: [320, 0],
    sizes: [
      [360, 60],
      [320, 50],
    ],
  },
];

const ViewPortSizeMappingInArticle300x250 = [
  {
    viewport: [1264, 0],
    sizes: [
      [970, 250],
      [300, 250],
      [300, 300],
    ],
  },
  {
    viewport: [876, 0],
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  {
    viewport: [300, 0],
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
];

const ViewPortSizeMappingInArticle336x280 = [
  {
    viewport: [1264, 0],
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [336, 280],
      [300, 250],
      [300, 300],
    ],
  },
  {
    viewport: [876, 0],
    sizes: [
      [336, 280],
      [300, 250],
      [300, 300],
    ],
  },
  {
    viewport: [300, 0],
    sizes: [
      [336, 280],
      [300, 250],
      [300, 300],
    ],
  },
];

export const CONFIG = {
  // Header Ads:
  // English-site
  EnPalo_HP_970x90_T1: {
    adUnit: "EnPalo_HP_970x90_T1", // home page
    sizes: [
      [970, 90],
      [728, 90],
      [468, 60],
      [320, 100],
      [320, 50],
    ],
    viewPortSizeMapping: ViewPortSizeMapping920X90T1,
  },
  EnPalo_ROS_728x90_T1: {
    adUnit: "EnPalo_ROS_728x90_T1", // listing page
    sizes: [
      [970, 90],
      [728, 90],
      [468, 60],
      [320, 100],
      [320, 50],
    ],
    viewPortSizeMapping: ViewPortSizeMapping920X90T1,
  },
  // bangla site
  Home_728x90_T1: {
    adUnit: "Home_728x90_T1", // home page
    sizes: [
      [970, 90],
      [728, 90],
      [468, 60],
      [320, 100],
      [320, 50],
    ],
    viewPortSizeMapping: ViewPortSizeMapping920X90T1,
  },
  News_728x90_T1: {
    adUnit: "News_728x90_T1", // listing page
    sizes: [
      [970, 90],
      [728, 90],
      [468, 60],
      [320, 100],
      [320, 50],
    ],
    viewPortSizeMapping: ViewPortSizeMapping920X90T1,
  },
  // english-site home page ads
  EnPalo_HP_336x280_R1: {
    adUnit: "EnPalo_HP_336x280_R1",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  EnPalo_HP_468x60_B1: {
    adUnit: "EnPalo_HP_468x60_B1",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [468, 60],
      [300, 250],
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1,
  },
  EnPalo_HP_336x280_R2: {
    adUnit: "EnPalo_HP_336x280_R2",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  EnPalo_HP_728x90_B2: {
    adUnit: "EnPalo_HP_728x90_B2",
    sizes: [[300, 250]],
  },
  EnPalo_ROS_468x60_B1: {
    adUnit: "EnPalo_ROS_468x60_B1",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [300, 250],
      [468, 60],
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1,
  },
  EnPalo_HP_300x250_R3: {
    adUnit: "EnPalo_HP_300x250_R3",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  EnPalo_HP_Floating_970x90: {
    adUnit: "EnPalo_HP_Floating_970x90",
    sizes: [
      [970, 90],
      [970, 66],
      [728, 90],
      [360, 60],
      [320, 50],
    ],
    viewPortSizeMapping: ViewPortSizeMappingFloating970x90,
  },
  // bangla-site home page ads
  Home_336x280_R1: {
    adUnit: "Home_336x280_R1",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  Home_468x60_B1: {
    adUnit: "Home_468x60_B1",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [468, 60],
      [300, 250],
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1,
  },
  Home_336x280_R2: {
    adUnit: "Home_336x280_R2",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  Home_728x90_B2: {
    adUnit: "Home_728x90_B2",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [468, 60],
      [300, 250],
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1,
  },
  News_468x60_B1: {
    adUnit: "News_468x60_B1",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [300, 250],
      [468, 60],
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1,
  },
  Home_336x280_R3: {
    adUnit: "Home_336x280_R3",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  Mobile_HP_Anchor: {
    adUnit: "Mobile_HP_Anchor",
    sizes: [
      [970, 90],
      [970, 66],
      [728, 90],
      [468, 60],
      [360, 60],
      [320, 50],
    ],
    viewPortSizeMapping: ViewPortSizeMappingFloating970x90,
  },
  // english-site inner pages
  EnPalo_ROS_336x280_R1: {
    adUnit: "EnPalo_ROS_336x280_R1",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  EnPalo_ROS_300x250_R2: {
    adUnit: "EnPalo_ROS_300x250_R2",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  EnPalo_ROS_336x280_R3: {
    adUnit: "EnPalo_ROS_336x280_R3",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  EnPalo_ROS_728x90_B2: {
    adUnit: "EnPalo_ROS_728x90_B2",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [300, 250],
      [468, 60],
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1,
  },
  EnPalo_InArticle_300x250: {
    adUnit: "EnPalo_InArticle_300x250",
    sizes: [
      [970, 250],
      [300, 250],
      [300, 300],
    ],
    viewPortSizeMapping: ViewPortSizeMappingInArticle300x250,
  },
  EnPalo_InArticle2_300x250: {
    adUnit: "EnPalo_InArticle2_300x250",
    sizes: [
      [970, 250],
      [300, 250],
      [300, 300],
    ],
    viewPortSizeMapping: ViewPortSizeMappingInArticle300x250,
  },
  EnPalo_Inner_Floating_970x90: {
    adUnit: "EnPalo_Inner_Floating_970x90",
    sizes: [
      [970, 90],
      [970, 66],
      [728, 90],
      [468, 60],
      [360, 60],
      [320, 50],
    ],
    viewPortSizeMapping: ViewPortSizeMappingFloating970x90,
  },
  // bangla-site inner page
  News_336x280_R1: {
    adUnit: "News_336x280_R1",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  News_336x280_R2: {
    adUnit: "News_336x280_R2",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  News_336x280_R3: {
    adUnit: "News_336x280_R3",
    sizes: [
      [300, 250],
      [300, 300],
    ],
  },
  News_728x90_B2: {
    adUnit: "News_728x90_B2",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [300, 250],
      [468, 60],
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1,
  },
  News_InArticle_300x250: {
    adUnit: "News_InArticle_300x250",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [336, 280],
      [300, 250],
      [300, 300],
    ],
    viewPortSizeMapping: ViewPortSizeMappingInArticle336x280,
  },
  News_InArticle2_300x250: {
    adUnit: "News_InArticle2_300x250",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [336, 280],
      [300, 250],
      [300, 300],
    ],
    viewPortSizeMapping: ViewPortSizeMappingInArticle336x280,
  },
  Mobile_Article_Anchor: {
    adUnit: "Mobile_Article_Anchor",
    sizes: [
      [970, 90],
      [970, 66],
      [728, 90],
      [468, 60],
      [360, 60],
      [320, 50],
    ],
    viewPortSizeMapping: ViewPortSizeMappingFloating970x90,
  },
  EnPalo_HP_Int_660x440: {
    adUnit: "EnPalo_HP_Int_660x440",
    sizes: [[1, 1]],
    renderOutOfThePage: true,
  },
  EnPalo_Inner_Int_660x440: {
    adUnit: "EnPalo_Inner_Int_660x440",
    sizes: [[1, 1]],
    renderOutOfThePage: true,
  },
  home_Int_660x440: {
    adUnit: "home_Int_660x440",
    sizes: [[1, 1]],
    renderOutOfThePage: true,
  },
  News_Int_660x440: {
    adUnit: "News_Int_660x440",
    sizes: [[1, 1]],
    renderOutOfThePage: true,
  },
  mcanvas1x1: {
    adUnit: "mCanvas_1x1",
    sizes: [[1, 1]],
  },
};

const getStoryType = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["qt", "data", "story", ["story-template"]]) || "text-story";
  } else {
    return "NA";
  }
};

const getStoryTypeOnAjax = (story) => {
  return get(story, ["story-template"], "text-story");
};

const getStorySectionName = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["qt", "data", "story", "sections", 0, "slug"]);
  } else if (pageType === "section-page") {
    return get(state, ["qt", "data", "section", "slug"]);
  }
  return "NA";
};

const getStorySectionNameOnAjax = (story) => {
  return get(story, ["sections", 0, "slug"], "NA");
};

const getStoryId = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["qt", "data", "story", "id"]) || "NA";
  }
  return "NA";
};

const getStoryIdOnAjax = (story) => {
  return get(story, ["id"], "NA");
};

const getCollectionSlug = (state, props) => {
  const pagetype = get(state, ["qt", "pageType"]);
  if (pagetype === "story-page") {
    return get(state, ["qt", "data", "story", "sections", 0, "name"]);
  }
  return get(props, ["collectionSlug"], "DefaultCollection");
};

const getCollectionSlugOnAjax = (story) => {
  return get(story, ["sections", 0, "name"], "DefaultCollection");
};

const getLayoutName = (state, props) => {
  const pagetype = get(state, ["qt", "pageType"]);
  if (pagetype === "story-page") {
    return "NA";
  }
  return get(props, ["layoutName"], "DefaultLayout");
};

const getTagList = (state, pageType) => {
  if (pageType === "story-page") {
    const tags = get(state, ["qt", "data", "story", "tags"], []);
    const tagList = tags.length > 0 ? tags.map((item) => item.name) : [];
    return tagList;
  }

  return [];
};

const getTagListOnAjax = (story) => {
  const tagList = story.tags && story.tags.length > 0 ? story.tags.map((item) => item.name) : [];
  return tagList;
};

const getSectionList = (state, pageType) => {
  if (pageType === "story-page") {
    const sections = get(state, ["qt", "data", "story", "sections"], []);
    const sectionList = sections.map((item) => item.name);
    return sectionList;
  }

  return [];
};

const getSectionListOnAjax = (story) => {
  const sectionList = story.sections && story.sections.length > 0 ? story.sections.map((item) => item.name) : [];
  return sectionList;
};

const DfpAdContent = (props) => {
  const { slotId } = props;

  return createDfpAdComponent({
    defaultNetworkID: "85406138",
    config: CONFIG,
    slotId,
    lazyLoad: { fetchMarginPercent: 0, renderMarginPercent: 0, mobileScaling: 2.0 },
    singleRequest: false,
    targeting: function (state, ownProps) {
      const pageType = get(state, ["qt", "pageType"]);
      const params = {
        publisherId: get(state, ["qt", "config", "publisher-id"]) || "",
        publisherName: get(state, ["qt", "config", "publisher-name"]),
        pageType: pageType,
        environment: get(state, ["qt", "config", "publisher-attributes", "env"]),
        storyType: ownProps.targetStory ? getStoryTypeOnAjax(ownProps.targetStory) : getStoryType(state, pageType),
        section: ownProps.targetStory
          ? getStorySectionNameOnAjax(ownProps.targetStory)
          : getStorySectionName(state, pageType),
        storyId: ownProps.targetStory ? getStoryIdOnAjax(ownProps.targetStory) : getStoryId(state, pageType),
        collectionSlug: ownProps.targetStory
          ? getCollectionSlugOnAjax(ownProps.targetStory)
          : getCollectionSlug(state, ownProps),
        layoutName: getLayoutName(state, ownProps),
        tagList: ownProps.targetStory ? getTagListOnAjax(ownProps.targetStory) : getTagList(state, pageType),
        sectionList: ownProps.targetStory
          ? getSectionListOnAjax(ownProps.targetStory)
          : getSectionList(state, pageType),
      };

      return params;
    },
  });
};

const DfpAd = (props) => {
  const { pageType, isVerticalMenubar } = props;
  const [showAd, setShowAd] = useState(true);

  useEffect(() => {
    if (
      window &&
      (window.location.href.includes("auth.prothomalo") || window.location.href.includes("auth-uat.prothomalo"))
    ) {
      const topAdElement = document.getElementById("top-ad");
      topAdElement.style.cssText = "display: none";
      setShowAd(false);
    }
  }, []);

  useEffect(() => {
    if (pageType !== "story-page" && isVerticalMenubar && global.deviceWidth < 876) {
      setShowAd(false);
      const topAdElement = document.getElementById("top-ad");

      if (topAdElement) {
        topAdElement.style.cssText = "min-height: 0";
      }
    } else {
      setShowAd(true);
    }
  }, [isVerticalMenubar]);

  if (!showAd) {
    return null;
  }

  const AdComponent = DfpAdContent(props);

  return (
    <div className="dfp-ad-unit">
      <AdComponent {...props} />
    </div>
  );
};

DfpAd.propTypes = {
  pageType: string,
  isVerticalMenubar: bool,
  slotId: string,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], ""),
  isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
});

export default connect(mapStateToProps)(DfpAd);
